export default "__VITE_ASSET__IvhC_B4b__"